import { Visibility, VisibilityOff } from "@material-ui/icons";
import { css } from "@emotion/react";
import styled from "../../../../config/emotion";
import { StyledCompProps } from "../../../../globalTypes/theme";
import { textFieldCss } from "../commonStyles";

export const VisibilityIcon = styled(Visibility)<StyledCompProps>`
  color: ${({ theme }) => theme.colors.primaryColor};
  cursor: pointer;
  font-size: 16px;
`;

export const VisibilityOffIcon = styled(VisibilityOff)<StyledCompProps>`
  color: gray;
  cursor: pointer;
  font-size: 16px;
`;

export const passwordFieldCss = css`
  ${textFieldCss()};
  width: calc(100% - 16px);
`;
